import React from 'react';
import PropTypes from 'prop-types';

import Container from 'common/container';
import BlogPost from 'common/blog-card';
import Markdown from 'common/markdown';
import CTA from '../index/cta';

const BlogCategoryPage = ({ title, description, posts, hasMore, onLoadMore }) => (
    <>
        <Container className="max-w-xxxl mb-12 lg:mb-16">
            <div className="max-w-md mt-24 text-center mx-auto">
                <h1 className="text-28 md:text-32 lg:text-36 font-black text-gray-90">{title}</h1>
                <Markdown className="mt-4 text-18 lg:text-21 text-gray-70 leading-relaxed">
                    {description}
                </Markdown>
            </div>

            <div className="mt-12 lg:mt-32">
                <div className="mt-8 lg:-mt-12">
                    {posts.map(post => (
                        <div key={post.id} className="pt-8 lg:pt-12">
                            <BlogPost {...post} />
                        </div>
                    ))}
                    {hasMore && (
                        <div className="pt-12 lg:pt-24 text-center">
                            <button
                                type="button"
                                className="link-green uppercase font-bold tracking-wide text-16 inline-block"
                                onClick={onLoadMore}
                            >
                                Load more
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </Container>
        <CTA />
    </>
);

BlogCategoryPage.propTypes = {
    slug: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    hasMore: PropTypes.bool.isRequired,
    onLoadMore: PropTypes.func.isRequired,
};

export default BlogCategoryPage;
